// Auto-generated from Foundry artifacts — DO NOT EDIT
// Source: packages/vault/contracts/out/AgentVaultFactory.sol/AgentVaultFactory.json

export const AGENT_VAULT_FACTORY_ABI = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_implementation",
        type: "address",
        internalType: "address",
      },
      {
        name: "_identityAdapter",
        type: "address",
        internalType: "address",
      },
      {
        name: "_feeModule",
        type: "address",
        internalType: "address",
      },
      {
        name: "_owner",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "MAX_MANAGEMENT_FEE_BPS",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint16",
        internalType: "uint16",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "MAX_PERFORMANCE_FEE_BPS",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint16",
        internalType: "uint16",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "UPGRADE_TIMELOCK",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "acceptOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "adapterUpgradeAfter",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "computeVaultAddress",
    inputs: [
      {
        name: "config",
        type: "tuple",
        internalType: "struct VaultConfig",
        components: [
          {
            name: "baseAsset",
            type: "address",
            internalType: "address",
          },
          {
            name: "creatorAgentId",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "managementFeeBps",
            type: "uint16",
            internalType: "uint16",
          },
          {
            name: "performanceFeeBps",
            type: "uint16",
            internalType: "uint16",
          },
          {
            name: "identityGated",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "metadataURI",
            type: "string",
            internalType: "string",
          },
          {
            name: "disclosure",
            type: "tuple",
            internalType: "struct VaultDisclosure",
            components: [
              {
                name: "strategyDescription",
                type: "string",
                internalType: "string",
              },
              {
                name: "strategyHash",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "riskRating",
                type: "uint8",
                internalType: "uint8",
              },
              {
                name: "disclaimerURI",
                type: "string",
                internalType: "string",
              },
            ],
          },
        ],
      },
      {
        name: "nonce",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "createVault",
    inputs: [
      {
        name: "config",
        type: "tuple",
        internalType: "struct VaultConfig",
        components: [
          {
            name: "baseAsset",
            type: "address",
            internalType: "address",
          },
          {
            name: "creatorAgentId",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "managementFeeBps",
            type: "uint16",
            internalType: "uint16",
          },
          {
            name: "performanceFeeBps",
            type: "uint16",
            internalType: "uint16",
          },
          {
            name: "identityGated",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "metadataURI",
            type: "string",
            internalType: "string",
          },
          {
            name: "disclosure",
            type: "tuple",
            internalType: "struct VaultDisclosure",
            components: [
              {
                name: "strategyDescription",
                type: "string",
                internalType: "string",
              },
              {
                name: "strategyHash",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "riskRating",
                type: "uint8",
                internalType: "uint8",
              },
              {
                name: "disclaimerURI",
                type: "string",
                internalType: "string",
              },
            ],
          },
        ],
      },
    ],
    outputs: [
      {
        name: "vault",
        type: "address",
        internalType: "address",
      },
      {
        name: "hook",
        type: "address",
        internalType: "address",
      },
      {
        name: "sharePool",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "executeIdentityAdapterUpgrade",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "executeImplementationUpgrade",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "feeModule",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IFeeModule",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getVaults",
    inputs: [
      {
        name: "offset",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "limit",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address[]",
        internalType: "address[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getVaultsByCreator",
    inputs: [
      {
        name: "agentId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "offset",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "limit",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address[]",
        internalType: "address[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "identityAdapter",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IIdentityRegistryAdapter",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "implementation",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "implementationUpgradeAfter",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isVault",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "pendingIdentityAdapter",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "pendingImplementation",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "pendingOwner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "proposeIdentityAdapter",
    inputs: [
      {
        name: "newAdapter",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "proposeImplementation",
    inputs: [
      {
        name: "newImpl",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "renounceOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "vaultCount",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "event",
    name: "IdentityAdapterUpdateProposed",
    inputs: [
      {
        name: "newAdapter",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "executeAfter",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "IdentityAdapterUpdated",
    inputs: [
      {
        name: "newAdapter",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ImplementationUpdateProposed",
    inputs: [
      {
        name: "newImplementation",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "executeAfter",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ImplementationUpdated",
    inputs: [
      {
        name: "newImplementation",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "OwnershipTransferStarted",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "VaultCreated",
    inputs: [
      {
        name: "vault",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "creatorAgentId",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "baseAsset",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "managementFeeBps",
        type: "uint16",
        indexed: false,
        internalType: "uint16",
      },
      {
        name: "performanceFeeBps",
        type: "uint16",
        indexed: false,
        internalType: "uint16",
      },
      {
        name: "nonce",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "error",
    name: "FailedDeployment",
    inputs: [],
  },
  {
    type: "error",
    name: "InsufficientBalance",
    inputs: [
      {
        name: "balance",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "needed",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "InvalidConfig",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidImplementation",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidRiskRating",
    inputs: [],
  },
  {
    type: "error",
    name: "ManagementFeeTooHigh",
    inputs: [],
  },
  {
    type: "error",
    name: "NoUpgradePending",
    inputs: [],
  },
  {
    type: "error",
    name: "OwnableInvalidOwner",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "OwnableUnauthorizedAccount",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "PerformanceFeeTooHigh",
    inputs: [],
  },
  {
    type: "error",
    name: "TimelockNotElapsed",
    inputs: [],
  },
  {
    type: "error",
    name: "ZeroAddress",
    inputs: [],
  },
] as const;

export const AGENT_VAULT_FACTORY_BYTECODE =
  "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" as const;
